import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";

import { PickUpSettingsSchema } from "Pages/OnlinePickUpTimes/schema";

import { useVenue } from "./VenueContext";
import { authorizedGet, authorizedPost } from "./authorizedRequests";
import { WeeklyScheduleSchema } from "./schema";

export type usageType = "view" | "engagement";
export const recordFeatureUsage = async ({
  featureName,
  usageType,
}: {
  featureName: string;
  usageType: usageType;
}) => {
  const response = await authorizedPost({
    url: "/v1/feature_usages",
    body: {
      feature_name: featureName,
      usage_type: usageType,
    },
  });
  return response;
};

export const useRecordFeatureUsage = () => {
  return useMutation({
    mutationFn: recordFeatureUsage,
  });
};

export const fetchPickUpSettings = (venueUuid: string) => async () => {
  const { body } = await authorizedGet({
    url: `/v1/venues/${venueUuid}/pick_up_settings`,
  });
  return PickUpSettingsSchema.parse(camelcaseKeys(body));
};
export const useFetchPickUpSettings = () => {
  const venueUuid = useVenue().uuid;
  return useQuery(
    queryOptions({
      queryKey: ["pickUpSettings"],
      queryFn: fetchPickUpSettings(venueUuid),
    }),
  );
};

const fetchOnlineOrderingSchedule = (uuid?: string) => async () => {
  if (!uuid) {
    return undefined;
  }
  const { body } = await authorizedGet({
    url: `/v1/weekly_schedules/${uuid}?deep=true`,
  });
  return WeeklyScheduleSchema.parse(
    camelcaseKeys(body.weekly_schedule, { deep: true }),
  );
};
export const useFetchOnlineOrderingSchedule = () => {
  const venue = useVenue();
  const uuid = venue.venueBrand.onlineOrderingWeeklyScheduleUuid || undefined;
  return useQuery(
    queryOptions({
      queryKey: ["onlineOrderingSchedule", uuid],
      queryFn: fetchOnlineOrderingSchedule(uuid),
      enabled: !!uuid,
    }),
  );
};
